module.exports = __webpack_public_path__ + "img/Abrare.946fca32.png";